import { gql } from '@apollo/client';

export const GET_STAGE_TEMPLATES = gql`
  query GetStageTemplates($filters: GetStageTemplatesFilters) {
    getStageTemplates(filters: $filters) {
      id
      name
      description
      statuses {
        name
        bgColor
      }
      fields {
        name
        type
      }
      applicationId
      createdDate
      updatedDate
    }
  }
`;
